
/**
 * Validates if a date string is in the format DD/MM/YYYY and represents someone who is at least 18 years old
 */
export const isValidDate = (dateString: string): boolean => {
  // Check format DD/MM/YYYY with regex
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    return false;
  }

  // Extract date parts
  const [day, month, year] = dateString.split('/').map(Number);
  
  // Check if it's a valid date
  const date = new Date(year, month - 1, day);
  if (
    date.getDate() !== day || 
    date.getMonth() !== month - 1 || 
    date.getFullYear() !== year
  ) {
    return false;
  }

  // Check if the person is at least 18 years old
  const today = new Date();
  const eighteenYearsAgo = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );

  return date <= eighteenYearsAgo;
};
